<quill-editor
  [class.minHeight]="minHeight()"
  [readOnly]="readonly()"
  (onContentChanged)="emitChange($event)"
  (onEditorCreated)="onEditorCreated($event)"
  [modules]="config"
  [sanitize]="false"
>
</quill-editor>
